import { PropsWithChildren, use } from 'react'

import { FormContext } from '../Context'

import { AutoCompleteFormProps } from './interface'

export const AutoCompleteForm = ({
  autoComplete = 'on',
  onSubmit,
  ...restProps
}: PropsWithChildren<AutoCompleteFormProps>) => {
  const { formNestedDeep } = use(FormContext)
  return formNestedDeep > 0 ? (
    <div {...restProps} />
  ) : (
    <form
      autoComplete={autoComplete}
      onSubmit={e => {
        e.preventDefault()
        e.stopPropagation()
        onSubmit?.(e)
      }}
      {...restProps}
    />
  )
}
